import { render } from "./CardLoader.vue?vue&type=template&id=10ef7fe9&scoped=true"
import script from "./CardLoader.vue?vue&type=script&lang=js"
export * from "./CardLoader.vue?vue&type=script&lang=js"

import "./CardLoader.vue?vue&type=style&index=0&id=10ef7fe9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ef7fe9"]])

export default __exports__